import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from "vue";
import headerMenu from "@/projects/tenant/modules/system/components/HeaderMenu.vue";
import groupPermission from "@/projects/tenant/modules/system/components/permission/GroupPermission.vue";
import userPermssion from "@/projects/tenant/modules/system/components/permission/UserPermission.vue";
import permissionList from "@/projects/tenant/modules/system/components/permission/PermissionList.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PermissionIndex',
  setup(__props) {

const tabs = ref([
  {
    name: "Role Permission",
    component: "groupPermission",
    id: 1,
  },
  {
    name: "User Permission",
    component: "userPermssion",
    id: 2,
  },
  {
    name: "Permission List",
    component: "permissionList",
    id: 3,
  },
]);
const componentMap = {
  groupPermission,
  userPermssion,
  permissionList,
};
const currentTab = ref(1);

const handleTabs = (id: number) => {
  currentTab.value = id;
};

const getComponent = (componentName: string) => {
  return componentMap[componentName];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(headerMenu, {
      tabs: tabs.value,
      onChangeTab: handleTabs
    }, null, 8, ["tabs"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: tab.id
      }, [
        (currentTab.value === tab.id)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(getComponent(tab.component)), { key: 0 }))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ], 64))
}
}

})